import { selectTitleWithDescriptionNode } from '@newStore/documentUI/transformContent/genericSelectors';
import { RequiredType, type RootNodeConfig } from '@nodeTypeConfig/configTypes';
import { authorsComponent } from '@nodeTypeConfig/helpers/editComponents/authorsComponent';
import { descriptionComponent } from '@nodeTypeConfig/helpers/editComponents/descriptionComponent';
import { publishComponent } from '@nodeTypeConfig/helpers/editComponents/publishComponent';
import { titleComponent } from '@nodeTypeConfig/helpers/editComponents/titleComponent';

const MARK_EXPLANATION: RootNodeConfig = {
  nodeSelector: selectTitleWithDescriptionNode,
  information: {
    definiteArticle: false,
    single: 'Markeerverklaring',
    plural: 'Markeerverklaringen',
    icon: require('../../../../img/icons/mark-explanation.svg'),
  },
  websiteHref: null,
  createModal: {
    authors: {
      addUser: true,
    },
  },
  buildingBlocks: [],
  tocTypes: [],
  edit: [
    titleComponent,
    {
      ...descriptionComponent,
      required: RequiredType.ERROR,
    },
    publishComponent,
    authorsComponent,
  ],
  isCreatable: true,
  isSearchable: true,
  allowSuggestions: false,
};

export default MARK_EXPLANATION;
